import { useClientValue } from "./useClientValue";

const clientTrue = () => true;

/**
 * Returns true once the component has mounted on the client.
 *
 * Useful for avoiding hydration mismatches when a value can only be known
 * after JavaScript runs (e.g. sessionStorage-derived ids, random values, or
 * browser APIs). During SSR and the first client render the hook returns false,
 * so both sides paint the same placeholder.
 */
export function useHydrated(): boolean {
  return useClientValue(clientTrue, false);
}
